import { observer } from 'mobx-react';

import styles from './TranslationEditorItem.module.scss';

import { TranslationsData } from 'chaika-frontend-types/frontend-cms';

import { OptionType, Select } from '@components/Select';
import { Input } from '@components/Input';
import { FieldTitle, FieldTitleTheme } from '@components/FieldTitle';
import { Icon, IconType } from '@components/Icon';
import { useHandlers } from './hooks/useHandlers';
import { translate } from '@chaika/i18n/helper';

interface Props {
    item: TranslationsData;
    selectedIds: string[];
    options: OptionType<string>[];
    dataTest: string;
    onChange(item: Partial<TranslationsData>): void;
    onDelete(): void;
}

export const TranslationEditorItem = observer(
    ({ dataTest, item, options, onChange, onDelete, selectedIds = [] }: Props) => {
        const { onItemChange } = useHandlers({ onChange, selectedIds });

        return (
            <div className={styles.root}>
                <div className={styles.title}>
                    <FieldTitle
                        theme={FieldTitleTheme.WithFlex}
                        title={translate('selectLanguageAndEnterName')}
                    />
                    <div
                        className={styles.delete}
                        onClick={onDelete}
                    >
                        <Icon type={IconType.TRASH_REDESIGN} />
                    </div>
                </div>

                <div className={styles.selectors}>
                    <Select
                        isClearable
                        isSearchable
                        hideSelectedOptions
                        placeholder={translate('chooseFromList')}
                        selectedValue={item.locale}
                        options={options}
                        onChange={onItemChange}
                        dataTest={`${dataTest}_select`}
                    />
                    <Input
                        type={'text'}
                        value={item.value}
                        onChange={event => onChange({ value: event.target.value ?? '' })}
                        dataTest={''}
                    />
                </div>
            </div>
        );
    },
);
